/**
 * 友達関連のクエリキー
 */
export const friendKeys = {
  all: ["friends"] as const,
  list: () => [...friendKeys.all, "list"] as const,
  myCode: () => [...friendKeys.all, "my-code"] as const,
};
